export enum ClvrPrscPosologyFrequencyGender {
    FEMININE,
    MASCULINE,
}
